import type { ProductConfig } from '../../default/product/product.types';
import type { DeepPartial } from '../../default/types';

export const productConfig: DeepPartial<ProductConfig> = {
  cliplister: {
    customerId: '157281',
  },
  aiUspPbks: [
    'Fernseher',
    'Waschmaschinen',
    '20_2_7_Shirts',
    '23_1_Schuhe',
    '31_1_Bettwäsche',
    'Armbänder',
    'Armbanduhren',
    'Bettlaken',
    'BHs',
    'Bikini-Oberteile',
    'Bikini-Sets',
    'Blusen',
    'Fingerringe',
    'Halsketten',
    'Komplettbetten',
    'Schränke',
    'Smartwatches',
    'Sofas',
  ],
  powerSupply: {
    pictogram: {
      included: 'https://bilder.quelle.de/i/empiriecom/FuAG_included.svg',
      notIncluded: 'https://bilder.quelle.de/i/empiriecom/FuAG_not_included.svg',
      specification: 'https://bilder.quelle.de/i/empiriecom/FuAG_specifications.svg',
    },
  },
};
